/**
 * formView
 * @Object {Object} axboot.formView
 */
axboot.formView = {
    getFormData: function () {
        return axboot.util.getFormToParam(this.target);
    },
    getData: function () {
        // ToDo : model 기준으로 변경
        //return this.model.model;
        //return axboot.util.getFormToParam(this.target);
        // input 에서 enter key 를 눌렀을 경우 model 이 바인딩이 안됨.
        return axboot.extend(this.model.model, axboot.util.getFormToParam(this.target));
    },
    getValue: function (dataPath) {
        var value = this.model.get(dataPath);

        if (ax5.util.isNothing(value)) {
            value = '';
        }

        return value;
    },
    setValue: function (dataPath, value) {
        this.model.set(dataPath, value);
    },
    clear: function () {
        this.model.setModel(this.getDefaultData());
        $('[data-ax5formatter]').ax5formatter('formatting');
    },
    disable: function () {
        //this.model.setModel(this.getDefaultData());
        //$('[data-ax5formatter]').ax5formatter('formatting');

        this.target.find(':input').attr('disabled', true);
    },
    enable: function () {
        //this.model.setModel(this.getDefaultData());
        //$('[data-ax5formatter]').ax5formatter('formatting');

        this.target.find(':input').attr('disabled', false);
    }
};

/**
 * formView.defaultData
 * @Object {Object} axboot.formView.defaultData
 */
axboot.formView.defaultData = {

};